import "./accountStatusModal.css";
import PopUpContainer from "../popUpContainer/PopUpContainer";

/**
 * The two terminal account states a seller can hit at the login screen.
 *
 * Both used to surface as a bare react-hot-toast — the denied one worded
 * indistinguishably from a mistyped password, the suspended one literally
 * returning "Invalid email or password". Neither told the person what had
 * actually happened or what to do next, which is the whole point of showing
 * a modal instead.
 *
 * `kind` is the response `type` from the backend verbatim
 * (services/auth/login.php and services/auth/verify_login.php), and `message`
 * is that response's payload string — the server stays the single source of
 * truth for the copy, so it can be reworded without a frontend deploy. The
 * static text below is only the framing around it.
 */
const COPY = {
  account_rejected: {
    icon: "fa fa-circle-xmark",
    title: "Application not approved",
    subtitle: "Your Sourship application was reviewed and was not approved.",
    className: "account-status-modal rejected",
    note: "No subscription charge was taken — the payment hold placed at signup has been released, and any amount already captured has been returned to your card.",
  },
  account_suspended: {
    icon: "fa fa-triangle-exclamation",
    title: "Account suspended",
    subtitle: "Your subscription payment was refunded or charged back.",
    className: "account-status-modal suspended",
    note: "Your subscription is what pays for access, so the account was closed automatically when the money was returned. Our team can restore it once the payment is settled.",
  },
};

function AccountStatusModal({ kind, message, onClose }) {
  const copy = COPY[kind];

  // Unknown kind — render nothing rather than an empty shell. Keeps a future
  // backend type from putting up a blank modal on an old build.
  if (!copy) return null;

  return (
    <PopUpContainer
      // PopUpContainer calls displayPopUp(false) from both the backdrop and
      // the X button, so onClose has to tolerate being handed that argument.
      displayPopUp={() => onClose()}
      popUpTitle={copy.title}
      popUpSubtitle={copy.subtitle}
      popUpIcon={copy.icon}
      popUpClassName={copy.className}
    >
      <div className="acct-status-body">
        <p className="acct-status-message">{message}</p>
        <p className="acct-status-note">{copy.note}</p>

        <div className="acct-status-actions">
          <a className="acct-status-support" href="mailto:support@sourship.com">
            <i className="far fa-envelope"></i> Contact support
          </a>
          <button type="button" className="acct-status-dismiss" onClick={() => onClose()}>
            Close
          </button>
        </div>
      </div>
    </PopUpContainer>
  );
}

export default AccountStatusModal;
